import Auth from "@aws-amplify/auth";
import { deleteWith, getWith, patchWith, postWith } from "../axios";
import { configPromise } from "../../config/configMiddleware";

export interface GetCurrentUserResponse { }

// export const checkCurrentUser = async (
//   setUserType: React.Dispatch<React.SetStateAction<string>>,
//   setUserRole: React.Dispatch<React.SetStateAction<string>>
// ): Promise<void> => {
//   const { attributes } = await Auth.currentAuthenticatedUser();
//   axios
//     .get(
//       "https://devapi.itradehub.io/api/v1/user/getUserByCognitoId/" +
//         attributes["custom:cognito_id"]
//     )
//     .then((userData) => {
//       const userRole = userData.data.data.user_roles[0].roles.role_name;
//       const UserType = userData.data.data.user_type;
//       setUserType(UserType);
//       setUserRole(userRole);
//     })
//     .catch((error) => {
//       console.log(error);
//     });
// };

export async function SignInUser(data: any): Promise<any> {
  try {
    const config = await configPromise;
    // const { attributes } = await Auth.currentAuthenticatedUser();
    const url = `${config.REACT_APP_API_URL}v1/user/signin`;

    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log("es", ex)
    throw ex.response.data;
  }
}

export async function SetPassword(data: any): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/user/set-password`;

    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetCurrentUser(): Promise<any> {
  try {
    const config = await configPromise;
    const { attributes } = await Auth.currentAuthenticatedUser();
    const url =
      `${config.REACT_APP_API_URL}v1user/getUserByCognitoId/` +
      attributes["custom:cognito_id"];

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetUserDetails(attributes: any): Promise<any> {
  try {
    const config = await configPromise;
    const url =
      `${config.REACT_APP_API_URL}v1/user/getUserByCognitoId/` +
      attributes["custom:cognito_id"];

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetUserDetailsByCognito(id: any): Promise<any> {
  try {
    const config = await configPromise;
    const url =
      `${config.REACT_APP_API_URL}v1/user/getUserByCognitoId/` + id;

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function activateOrganization(orgID: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/organization/activate-org`;
    const data = { org_id: orgID };
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function activateUser(ID: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/user/activate-user`;
    const data = { id: ID };
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function InviteUser(ID: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/organization/invite-user`;
    return (await postWith<any, any>(url, { id: ID })) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetUserProfile(id: string | undefined): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/user/` + id;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getUserByCognitoId(id: string | undefined): Promise<any> {
  try {
    const config = await configPromise;
    const url =
      `${config.REACT_APP_API_URL}v1/user/getUserByCognitoId/` + id;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getUserByEmailId(
  email_id: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url =
      `${config.REACT_APP_API_URL}v1/user/getUserByEmailId/` + email_id;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getUserByPartner(
  partnew_id: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url =
      `${config.REACT_APP_API_URL}v1/user/fetch-users-of-partner/` +
      partnew_id;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getTeamMembers(orgID: string, pageNumber: number): Promise<any> {
  try {
    const config = await configPromise;
    const url =
      `${config.REACT_APP_API_URL}v1/user/fetch-users/organization/${pageNumber}/`
    // orgID +
    // "/1/";
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}


export async function addTeamMember(req: any): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/user/org-user`;
    return (await postWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function updateTeamMember(id: string, req: any): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/user/${id}`;
    return (await patchWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function deleteTeamMember(id: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/user/${id}`;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function inviteTeamMember(req: any): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/organization/invite-user`;
    return (await postWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}